import React from "react";
import { Collapse } from "antd";
import { useAuth } from "../Auth/AuthProvider";

const { Panel } = Collapse;

export default function PermissionPanel({
    permission,       // required permission string
    placeIds = [],    // optional array of allowed placeIds
    header,
    children,
    ...rest
}) {
    const { permissions } = useAuth();
    const loginPlaceId = localStorage.getItem("placeId");

    // Must have the permission
    if (!permissions.includes(permission)) return null;

    // If placeIds provided, check loginPlaceId
    if (placeIds.length > 0 && !placeIds.includes(loginPlaceId)) return null;

    // Otherwise show panel
    return (
        <Panel header={header} {...rest}>
            {children}
        </Panel>
    );
}
